var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 25,
    viewBox: "0 0 6 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.541748 2.50204C0.541748 1.12153 1.66328 -1.69533e-07 3.04379 -1.09189e-07C4.42021 -4.90238e-08 5.54175 1.12153 5.54175 2.50204C5.54175 3.88254 4.42021 5.00408 3.04379 5.00408C1.66328 5.00408 0.541748 3.88254 0.541748 2.50204ZM0.541748 12.229C0.541749 10.8485 1.66328 9.727 3.04379 9.727C4.42021 9.727 5.54175 10.8485 5.54175 12.229C5.54175 13.6095 4.42021 14.7311 3.04379 14.7311C1.66328 14.7311 0.541748 13.6095 0.541748 12.229ZM3.04379 19.454C1.66328 19.454 0.541749 20.5755 0.541749 21.956C0.541748 23.3365 1.66328 24.4581 3.04379 24.4581C4.42021 24.4581 5.54175 23.3365 5.54175 21.956C5.54175 20.5755 4.42021 19.454 3.04379 19.454Z",
    fill: "#B1BCC7",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalOption);
export default __webpack_public_path__ + "static/media/vertical-option.403a324d254a837bd30bac286342d26e.svg";
export { ForwardRef as ReactComponent };